import React from 'react';
import { Card } from '@one-thd/sui-atomic-components';
import Spinner from '../shared/spinner/spinner';

export const LoadingCard = () => {
  return (
    <Card
      grow
      PaperProps={{ className: 'sui-h-full sui-min-h-[325px] sui-relative ' }}
      data-component="ShippingAddressCardLoadingCard"
    >
      <Spinner active />
    </Card>
  );
};

LoadingCard.displayName = 'LoadingCard';